module.exports = __webpack_public_path__ + "img/cashout.8d269345.svg";